import React from 'react';
import {
  TouchableOpacity,
  View,
  StyleProp,
  StyleSheet,
  ViewStyle,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import SVG from '../../assets/svg';
import { ICONS } from '../constants/colors';

type IconSize = 'xsmall' | 'small' | 'medium' | 'large';

type Props = {
  name: SVGKeys | string;
  size?: IconSize;
  color?: string;
  iconStyle?: StyleProp<ViewStyle>;
  onPress?: () => void;
  disabled?: boolean;
};

const ICON_SIZE = {
  xsmall: 20,
  small: 24,
  medium: 30,
  large: 40,
};

const isCustom = (x: string): x is SVGKeys => SVG.hasOwnProperty(x);

export default function Icon(props: Props) {
  let {
    name,
    size,
    iconStyle,
    onPress,
    color,
    disabled = false,
    ...otherProps
  } = props;
  let iconSize = ICON_SIZE[size || 'small'];
  let iconColor = color || ICONS.default;
  let icon;

  if (isCustom(name)) {
    icon = React.createElement(SVG[name as SVGKeys], {
      fill: color,
      width: iconSize,
      height: iconSize,
    });
  } else {
    icon = (
      <MaterialCommunityIcons name={name} size={iconSize} color={iconColor} />
    );
  }

  if (onPress) {
    return (
      <TouchableOpacity
        style={[styles.container, iconStyle]}
        disabled={disabled}
        onPress={onPress}
        {...otherProps}
      >
        {icon}
      </TouchableOpacity>
    );
  } else {
    return (
      <View style={[styles.container, iconStyle]} {...otherProps}>
        {icon}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    margin: 5,
  },
});
